import React from 'react';
import { Redirect } from 'react-router-dom';
import ChangePassword from './components/Changepassword';
import Modal from '../../components/Modal/Modal';
import { AuthContext } from '../../context/Auth/Auth';
import { Changepasswordcontext } from '../../context/Changepassword/Changepassword';
import modalReducer, { initialState } from '../../reducers/Modal.reducer';

const ChangepasswordPage = () => {
  const [state, dispatch] = React.useReducer(modalReducer, initialState);
  const { resetPasswordToken } = React.useContext(Changepasswordcontext);
  const { isLoggedIn } = React.useContext(AuthContext);

  const closeModal = React.useCallback(() => {
    dispatch({ type: 'CLOSE_MODAL' });
  }, []);

  const showModalError = React.useCallback((errorMessage: string) => {
    dispatch({ type: 'SHOW_MODAL_ERROR', payload: errorMessage });
  }, []);

  return (
    <React.Fragment>
      {resetPasswordToken === '' && !isLoggedIn ? (
        <Redirect to="/" />
      ) : (
        <React.Fragment>
          <ChangePassword showModalError={showModalError} />
          <Modal show={state.showModal} error={state.error} errorMessage={state.errorMessage} closeModal={closeModal} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ChangepasswordPage;
